module.exports = __webpack_public_path__ + "img/undraw_art_0tat.93e34c0e.svg";